interface AggGoalTabConfig {
	id: string;
}

interface AggGoalTabs {
	about: AggGoalTabConfig;
	updates: AggGoalTabConfig;
	jiraAlign: AggGoalTabConfig;
	jira: AggGoalTabConfig;
	projects: AggGoalTabConfig;
	learnings: AggGoalTabConfig;
	risks: AggGoalTabConfig;
	decisions: AggGoalTabConfig;
}

const aggGoalTabs: AggGoalTabs = {
	about: {
		id: 'goal-about-tab',
	},
	updates: {
		id: 'goal-updates-tab',
	},
	jiraAlign: {
		id: 'goal-jira-align-tab',
	},
	jira: {
		id: 'goal-jira-tab',
	},
	projects: {
		id: 'goal-projects-tab',
	},
	learnings: {
		id: 'goal-learnings-tab',
	},
	risks: {
		id: 'goal-risks-tab',
	},
	decisions: {
		id: 'goal-decisions-tab',
	},
};

export const AGG_GOAL_TABS: typeof aggGoalTabs = aggGoalTabs;

export type AggGoalTabName = keyof typeof AGG_GOAL_TABS;

export const DEFAULT_TAB: AggGoalTabName = 'about';

export const isAggGoalTab = (tabName: string): tabName is AggGoalTabName => {
	return tabName in AGG_GOAL_TABS;
};
